import React, { useEffect, useState } from "react";
import Axios from "../../../_services/caller.service";
import { useCabineContext } from "../../../context/CabineContext";
import styles from "./ChangeAdressCab.module.scss";
import { encodedB64 } from "../../../CustomHooks/DecodedBase64";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import InputForms from "../../UiComponents/forms/InputForms";
import { PermissionGate } from "../managePermissions/PermissionGate";

const ChangeAdressCab = ({
  cabId,
  majCabine,
  setMajCabine,
}) => {
  const { cabine } = useCabineContext();
  const { t } = useTranslation();
  const [dataAdress, setDataAdress] = useState(null);
  const [updatedDataAdress, setUpdatedDataAdress] = useState({});
  const [count, setCount] = useState(0);

  useEffect(() => {
    const getCabineAdress = () => {
      if (cabine !== "") {
        Axios.get(`/cabineAdress/${cabId}`)

          .then(function async(response) {
            // Si des données sont reçues, mettez à jour l'état dataAdress avec ces données
            if (response.data.data) {
              const newDataAdress = {
                Responsable: response.data.data.Responsable || "",
                Tel: response.data.data.Tel || "",
                Adress: response.data.data.Adress || "",
                Adress2: response.data.data.Adress2 || "",
                CodePostal: response.data.data.CodePostal || "",
                Ville: response.data.data.Ville || "",
                Pays: response.data.data.Pays || "",
              };
              setDataAdress(newDataAdress);
            } else {
              // Sinon, réinitialisez l'état dataAdress avec les valeurs par défaut
              setDataAdress({
                Responsable: "",
                Tel: "",
                Adress: "",
                Adress2: "",
                CodePostal: "",
                Ville: "",
                Pays: "",
              });
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }
    };
    getCabineAdress();
  }, [cabId, cabine, majCabine, count]);

  const handleChangeAdress = (e) => {
    setUpdatedDataAdress({
      ...updatedDataAdress,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async () => {
    Axios.post(`/createCatidApplicationData/${cabId}`)
      .then((response) => {
        const completeData = {
          ...dataAdress,
          ...updatedDataAdress,
        };

        const base64EncodedData = Object.fromEntries(
          Object.entries(completeData).map(([key, value]) => [
            key,
            encodedB64(value),
          ])
        );

        Axios.put(`/updateCabineAdress/${cabId}`, {
          data: base64EncodedData,
        })
          .then((response) => {
            if (response.data.message === "aucun changement effectués") {
              toast.error(t("superadmin_ui.no_data_change"));
            } else {
              toast.success(t("superadmin_ui.new_data_saved"));
              setCount((prev) => prev + 1);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch((error) => {});
  };

  return (
    <div className={styles.infosAdress}>
      <div className={styles.containerModal}>
        {dataAdress &&
          Object.entries(dataAdress).map(([key, value]) => (
            <div className={styles.adress} key={key}>
              <div className={styles.containerLabel}>
                <label>{key}:</label>
              </div>
              <div className={styles.containerInput}>
                {/* <input
                  name={key}
                  defaultValue={value}
                  onChange={handleChangeAdress}
                /> */}
                <InputForms
                  name={key}
                  defaultValue={value}
                  onChange={handleChangeAdress}
                  id={styles.inputChangeAdress}
                />
              </div>
            </div>
          ))}

        <div className={styles.btnUpdate}>
          <PermissionGate actionKey="cabines.adress.update">  
          <button className={styles.btnUpdate} onClick={handleUpdate}>
            {t("common.confirm_update")}
          </button>
          </PermissionGate>
        </div>
      </div>
    </div>
  );
};

export default ChangeAdressCab;
